/*******************
@Purpose : We can use following api calls and can change api name easily
@Author : INIC
******************/
export default {
  //Authentication
  LOGIN: "on-boarding",
  SUBMIT_OTP: "on-boarding-otp-verify",
  SUBMIT_GUEST_OTP: "guest/on-boarding-otp-verify",
  LOGOUT: "logout",
  SOCIAL_LOGIN: "guest/on-boarding-social",
  GOOGLE_AUTH: "https://www.googleapis.com/oauth2/v3/userinfo",

  //Users
  USER_DETAILS: "profile",
  DOCUMENT_UPLOAD: "profile/documents",
  DELETE_LICENSE: "profile/documents-delete-licence",
  DELETE_INSURANCE: "profile/documents-delete-insurance",
  LICENCE_VERIFICATION: "profile/licence-verification",
  LICENCE_ADDRESS_APPLY: "profile/licence-verification/address/apply",
  LICENCE_ADDRESS_DISMISS: "profile/licence-verification/address/dismiss",
  SEND_VERIFY_EMAIL: "verify/email",
  VERIFY_EMAIL: "verify/email-link",
  VERIFY_NUMBER: "verify/number",
  VERIFY_OTP: "verify/number-otp",
  GUEST_PROFILE: "guest/profile",

  // trips
  TRIP_LIST: "trip/reservation-list",
  TRIP_DETAIL: "trip/details",
  TRIP_INVOICE: "trip/invoice",

  // home
  HOME_DATA_API: "dynamic-page/home",
  LOCATIONS: "locations",
  BRAND_CATEGORY_BANNER_DETAILS: "banners",
  BRAND_CATEGORY_VEHICLE_DATA: "vehicles",
  SETTINGS: "settings",
  DYNAMIC_PAGES_LIST: "dynamic-pages-list",
  FEATURES: "features",
  SEO_TAGS: "seo-tags",
  SEARCHBRANDVEHICLE: "search",
  SET_SHOW_MENU: "showmenu",
  FAQS: "faqs",
  USER_DELETE: "delete",

  //common
  BRAND_LIST: "brands",
  CATEGORY_LIST: "fleets",
  BRAND_VEHICLE_LIST: "brand",

  // brand
  VEHICLE_FILTER_INPUT: "vehicles/filter-data",
  VEHICLE_FILTER: "vehicles/filter",
  VEHICLE_SEARCH_RESULTS: "vehicles/search-results",
  VEHICLE_FLEXIBLE: "vehicles/flexible",
  GET_BRAND_INFO: "brands",
  COLORS: "colors",

  // vehicle
  VEHICLES: "vehicles",
  VEHICLES_AVAILABILITY: "vehicle-availability",

  // contact us
  CONTACT_US: "contact-us",

  // blog
  BLOGS: "blogs",
  BLOGSDETAIL: "blogs",

  //payment
  CREDIT_CARD_SAVE: "credit-card/save",
  CREDITE_CARD_DETAILS: "credit-card/details",
  DELETE_CREDIT_CARD_DETAILS: "credit-card/delete",

  //booking
  GET_RESERVATION_DETAILS: "booking/bookingId/details",
  APPLY_PROMOCODE: "booking/promocode/verify",
  REMOVE_PROMOCODE: "booking/promocode/remove",
  BOOKING_SAVE: "booking/save",
  BOOKING_REQUEST: "booking/request",
  BOOKING_ORDER: "booking/order/place",
  BOOKING_TOKEN_GENRATE: "booking/bookingId/payment-token",

  STABLECOIN_PAYMENT_INTENT_TOKEN_GENERATE: "booking/bookingId/stablecoin-payment-intent",
  STABLECOIN_CHECK_AVAILABILITY: "booking/bookingId/check-availability",
  STABLECOIN_PLACE_ORDER: "booking/stablecoin/order/place",
  CRYPTO_CHECKOUT_CONFIRM: "booking/crypto/order/confirm",
  CRYPTO_CHECKOUT_CANCEL: "booking/crypto/order/cancel",

  USER_PHONE_EXIST: "user-phone-exists",
  DISTANCE_METRIX: "distance-matrix",

  //sitemap
  SITEMAP: "sitemap",

  //locations
  GET_COUTNRIES: "countries",
  GET_STATES: "countries/{id}/states",
  GET_CITIES: "states/{id}/cities",
  INSURANCE_CARRIERS: "insurance-carriers",

  //favorite / unfevorite
  USER_FAVORITE: "user/favourite",
  USER_FAVORITES: "user/favourites",

  // klaviyo
  KLAVIYO_SUBSCRIBE: "klaviyo/subscribe",

  // sign contract
  SIGN_CONTRACT: "trip/sign-contract",
};
